import PropTypes from 'prop-types'
import React from 'react'
import Plx from 'react-plx'

import SectionWrapper from 'components/SectionWrapper'
import { ResizeContext } from 'contexts/Resize'
import { Row, Col } from 'styles/components/layout'
import { H2, Text } from 'styles/components/typography'

import dnaImage from './assets/dna.svg'
import { Wrapper, Dna, DnaImage, Article } from './styles'

const parallaxData = [
  {
    start: 'self',
    duration: '200vh',
    properties: [
      {
        startValue: -400,
        endValue: -100,
        property: 'translateY',
      },
    ],
  },
]

const DAboutDefinition = ({ data }) => {
  const { mobile, breakpoint } = React.useContext(ResizeContext)
  const DnaImageComponent = React.useMemo(
    () =>
      !breakpoint || mobile ? (
        <Dna>
          <DnaImage alt="" src={dnaImage} />
        </Dna>
      ) : (
        <Dna>
          <Plx parallaxData={parallaxData}>
            <DnaImage alt="" src={dnaImage} />
          </Plx>
        </Dna>
      ),
    [mobile, breakpoint],
  )

  return (
    <SectionWrapper beforeElement={DnaImageComponent}>
      <Row>
        <Col width={{ xs: 1, md: 7 / 12, lg: 6 / 12 }}>
          <Wrapper>
            <Article>
              <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
              <Text dangerouslySetInnerHTML={{ __html: data.content }} />
            </Article>
          </Wrapper>
        </Col>
      </Row>
    </SectionWrapper>
  )
}

DAboutDefinition.propTypes = {
  /** Data for block */
  data: PropTypes.object.isRequired,
}

DAboutDefinition.defaultProps = {}

export default DAboutDefinition
